import Dashboard from '../assets/Dashboard.png'
import CreativeDesign from '../assets/CreativeDesign.png'
import InfiniteLuxe from '../assets/InfiniteLuxe.png'

const Experience = () => {
  return (
    <div name='experience' className='w-full min-h-screen py-16 my-24 md:h-full bg-[rgb(255,255,255)] flex justify-center items-center pb-20'>
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'> 
          <div className='sm:text-left pb-8 pl-2'>
            <p className='text-4xl font-bold inline border-b-2 border-[#d4d4d4] cursor-default'>Experience</p>
          </div>

          <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4 z-[1]'>
 
          {/* First  */}
            <div style={{backgroundImage: `url(${InfiniteLuxe})`}} className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>

              {/* Hover effects */}
              <div className='opacity-0 group-hover:opacity-100 duration-200'>
                  <span className='text-2xl font-bold text-black tracking-wider cursor-default'>
              Infinite Luxe Boutique
                  </span>
                <div className='pt-8 text-center'>
                <a target='_blank' href="https://infiniteluxeboutique.pl/">
                    <button className='text-center rounded-lg px-4 py-3 m-2 font-bold text-lg bg-[#e0b02d88]'>Demo</button>
                </a>
                </div>
              </div>
              </div>

              {/* Second */}
              <div style={{backgroundImage: `url(${CreativeDesign})`}} className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>


              {/* Hover effects */}
              <div className='opacity-0 group-hover:opacity-100 duration-200'>
                  <span className='text-2xl font-bold text-black tracking-wider cursor-default'>
              CreativeDesign 
                  </span>
                <div className='pt-8 text-center'>
                <a target='_blank' href="https://statuesque-speculoos-fb8291.netlify.app/">
                        <button className='text-center rounded-lg px-4 py-3 m-2 font-bold text-lg bg-[#d4d4d4]'>Demo</button>
                      </a>
                  <a target='_blank' href="https://github.com/PatrykR01/Project-of-Website">
                    <button className='text-center rounded-lg px-4 py-3 m-2 font-bold text-lg bg-[#d4d4d4]'>Code</button>
                  </a>
                </div>
              </div>
              </div>

              <div style={{backgroundImage: `url(${Dashboard})`}} className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>

                  {/* Hover effects */}
                  <div className='opacity-0 group-hover:opacity-100 duration-200'>
                      <span className='text-2xl font-bold text-black tracking-wider cursor-default'>
                          Dashboard NextJS
                      </span>
                    <div className='pt-8 text-center'>
                      <a target='_blank' href="https://starlit-cocada-56288c.netlify.app/">
                        <button className='text-center rounded-lg px-4 py-3 m-2 font-bold text-lg bg-[#d4d4d4]'>Demo</button>
                      </a>
                      <a target='_blank' href="https://github.com/PatrykR01/dashboard-nextjs">
                    <button className='text-center rounded-lg px-4 py-3 m-2 font-bold text-lg bg-[#d4d4d4]'>Code</button>
                  </a>
                    </div>
                  </div>
                  </div>
          </div>
        </div>
    </div>
  )
}

export default Experience